import React from "react"
import styles from "./validation-message.module.css"
interface ValidationMessageProp {
    name: string,
    value: any,
    errors: any,
    register: any,
    message: string

}
interface ValidationMessageProp {
    name: string,
    value: any,
    errors: any,
    register: any,
    message: string,
    min?: number

}

const RequiredMessage = (prop: ValidationMessageProp) => {
    if (!prop.name || typeof prop.name !== 'string') {
        return null;
    }
    const safeValue = prop.value != null ? String(prop.value) : "";
    return (
        <>
            <input
                className="hidden"
                name={prop.name}
                readOnly
                ref={prop.register({ required: true, minLength: 1 })}
                value={safeValue}
            />
            {prop.errors[`${prop.name}`] && <p className={styles.message}>{prop.message}</p>}
        </>
    )
}
const MinValidateMessage = (prop: ValidationMessageProp) => {
    if (!prop.name || typeof prop.name !== 'string') {
        return null;
    }
    const safeValue = prop.value != null ? String(prop.value) : "";
    return (
        <>
            <input
                className="hidden"
                name={prop.name}
                readOnly
                ref={prop.register({ required: true, minLength: 1, min: prop.min ? prop.min : 1 })}
                value={safeValue}
            />
            {prop.errors[`${prop.name}`] && <p className={styles.message}>{prop.message}</p>}
        </>
    )
}
export { RequiredMessage, MinValidateMessage }